export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="#25479A">
        <path d="M9 19.05L0 12.05L1.65 10.8L9 16.5L16.35 10.8L18 12.05L9 19.05ZM9 14L0 7L9 0L18 7L9 14ZM9 11.45L14.75 7L9 2.55L3.25 7L9 11.45Z" fill="#25479A" />
    </svg>
);